import React from "react";
import { INTERCEPT_CHAT } from "./interceptContent.js";

const InterceptChat = () => (
  <div className="cursor-intercept-phone" data-testid="quiet-intercept-chat">
    <div className="cursor-intercept-phone-shell">
      <div className="cursor-intercept-phone-header">
        <div className="cursor-intercept-phone-status">
          <span className="cursor-intercept-phone-time">
            {INTERCEPT_CHAT.statusTime} · {INTERCEPT_CHAT.statusDay}
          </span>
          <div className="cursor-intercept-phone-online">
            <span className="cursor-intercept-phone-online-ping" aria-hidden="true" />
            <span className="cursor-intercept-phone-online-dot" aria-hidden="true" />
            <span className="cursor-intercept-phone-online-label">ONLINE</span>
          </div>
        </div>
        <p className="cursor-intercept-phone-business">{INTERCEPT_CHAT.businessName}</p>
        <p className="cursor-intercept-phone-sub">Typically replies instantly</p>
      </div>

      <div className="cursor-intercept-phone-thread">
        {INTERCEPT_CHAT.messages.map((message) => {
          const isCustomer = message.role === "customer";

          return (
            <div
              key={message.id}
              className={`cursor-intercept-phone-row${isCustomer ? " cursor-intercept-phone-row-customer" : ""}`}
            >
              <div
                className={`cursor-intercept-phone-bubble${
                  isCustomer
                    ? " cursor-intercept-phone-bubble-customer"
                    : message.highlight
                      ? " cursor-intercept-phone-bubble-booked"
                      : " cursor-intercept-phone-bubble-ai"
                }`}
              >
                {message.text}
              </div>
            </div>
          );
        })}
      </div>

      <div className="cursor-intercept-phone-footer">
        <div className="cursor-intercept-phone-input">iMessage</div>
      </div>
    </div>
  </div>
);

export default InterceptChat;
